<template>
  <div>
    <ul class="Fuell-Tabs">
      <li class="Fuell-Tabs--tab">
        <router-link
          :to="{name:'reimbursements_pending'}"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{ path: 'transactions_reimbursements_subsection_pending' }"
        ></router-link>
      </li>
      <li class="Fuell-Tabs--tab">
        <router-link
          :to="{name:'reimbursements_history'}"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{ path: 'transactions_reimbursements_subsection_history' }"
        ></router-link>
      </li>
    </ul>
    <router-view
      :key="$route.path"
      :hideReviewInfo="hideReviewInfo"
      :hideMissingInfo="hideMissingInfo"
    ></router-view>
  </div>
</template>

<script>

export default {
  name: 'ReimbursementsIndex',
  data () {
    return {
      hideReviewInfo: false,
      hideMissingInfo: false,
      componentKey: 0
    }
  }
}
</script>
